import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) { }

  getUserByUsername(username: string) {
    return this.http.get<any>(
      `${environment.API_URL_SEC}/api/secusers/${username}`);
  }


  addUser(username: string, password: string, displayName: string, email: string, mobile: string, userType: string, candidateid: number, studentid: number, teacherid: number, active: string) {
    // console.log(password);
    return this.http.post<any>(
      `${environment.API_URL_SEC}/api/adduser`, { username, password, displayName, email, mobile, userType, candidateid, studentid, teacherid, active });
  }

  updateUser(id: number, username: string, displayName: string, email: string, mobile: string, userType: string, candidateid: number, studentid: number, teacherid: number, active: string
    // , userOrgs: any[]
    , userRoles: any[]) {
    return this.http.put<any>(
      `${environment.API_URL_SEC}/api/secusers/${id}`, { id, username, displayName, email, mobile, userType, candidateid, studentid, teacherid, active, userRoles });
  }

  updateAllUser(user: any) {
    return this.http.put<any>(
      `${environment.API_URL_SEC}/api/secusers/${user?.id}`, user);
  }

  deleteUserById(id: number) {
    return this.http.delete<any>(
      `${environment.API_URL_SEC}/api/secusers/${id}`);
  }

  addUserOrg(username: string, orgid: number, userid: number) {
    return this.http.post<any>(
      `${environment.API_URL_SEC}/api/secuserorgs`, { username, orgid, userid });
  }

  updateUserOrg(id: number, username: string, orgid: number) {
    return this.http.put<any>(
      `${environment.API_URL_SEC}/api/secuserorgs`, { id, username, orgid });
  }

  getUserOrg(username: string) {
    return this.http.get<any>(
      `${environment.API_URL_SEC}/api/secuserorgs/${username}`);
  }

  addUserRole(userid: number, roleid: number, grantedFrom: Date, grantedTo: Date, active: String) {
    return this.http.post<any>(
      `${environment.API_URL_SEC}/api/secuserroles`, { userid, roleid, grantedFrom, grantedTo, active });
  }

  updateRole(userid: number, username: string, roleid: number, grantedFrom: Date, grantedTo: Date, active: string) {
    return this.http.put<any>(
      `${environment.API_URL_SEC}/api/secuserroles`, { userid, username, grantedFrom, grantedTo, roleid, active });
  }

  updateUserProfile(id: number, email: string, displayName: string, mobile: string) {
    return this.http.put<any>(
      `${environment.API_URL_SEC}/api/secusers/${id}`, { id, email, displayName, mobile });
  }

  searchByUsername(username: string) {
    return this.http.get<any>(
      `${environment.API_URL_SEC}/api/secsearchusers/${username}`);
  }

  changePass(username: string , oldPass: string,newPass: string) {
    return this.http.get<any>(
      `${environment.API_URL_SEC}/api/secuserschangepass/${username}/${oldPass}/${newPass}`);
  }

  createPass(username: string ,newPass: string) {
    return this.http.get<any>(
      `${environment.API_URL_SEC}/api/secuserscreatepass/${username}/${newPass}`);
  }

  restPass(username: string , userId: any) {
    return this.http.get<any>(
      `${environment.API_URL_SEC}/api/secusersrestpass/${userId}/${username}`);
  }

  deleteRoleByUser(uid: number) {
    return this.http.delete<any>(
      `${environment.API_URL_SEC}/api/secuserrolesbyuser/${uid}`);
  }
  UpdateUserRole(userid: number,roleid: number, active:String) {
    return this.http.put<any>(
      `${environment.API_URL_SEC}/api/secuserroles/${userid}/${roleid}`,{ userid, roleid, active });
  }
}
